(function () {
    'use strict';

    angular
        .module('actionPlanModule')
        .controller('grcActionPlanEditModalController', Controller);

    Controller.$inject = ['$scope', 'grcActionPlanService'];

    function Controller($scope, grcActionPlanService) {

        $scope.ctrlCtxt = {
            isUserSelectModalDisplayed: false
        };

        // On Select User Modal Open
        $scope.onOpenSelectUser = function () {
            $scope.ctrlCtxt.isUserSelectModalDisplayed = true;
        };

        // On Select User Modal Closed
        $scope.onSelectUserClosed = function () {
            $scope.ctrlCtxt.isUserSelectModalDisplayed = false;
        };

        // Select Owner
        $scope.selectOwner = function (person) {
            $scope.actionPlan.Owner = person;
            $scope.actionPlan.OwnerID = person.ItemPersonID;
        }

        // Select Owner Delegate
        $scope.selectOwnerDelegate = function (person) {
            $scope.actionPlan.OwnerDelegate = person;
            $scope.actionPlan.OwnerDelegateID = person.ItemPersonID;
        };

        // Cancel Modal
        $scope.cancel = function () {
            $scope.close();
        };

        // Update ActionPlan
        $scope.updateActionPlan = function () {
            grcActionPlanService
                .updateActionPlan($scope.actionPlan)
                .then(function (updatedActionPlan) {
                    $scope.onSave();
                });
        };

    }
})();
